import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=17633ab0&scoped=true&"
import script from "./AudioPlay.vue?vue&type=script&lang=js&"
export * from "./AudioPlay.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&id=17633ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17633ab0",
  null
  
)

export default component.exports